import { useAlert } from 'dashboard/composables';

// Event is targeted by the backend. Fetch again before exposing the action:
// visibility may have changed while the event was queued.
export function createTransferToast(app, fetchConversation) {
  const seen = new Set();
  return async data => {
    const accountId = app.$store.getters.getCurrentAccountId;
    if (
      Number(data.account_id) !== Number(accountId) ||
      seen.has(data.event_id)
    )
      return;
    seen.add(data.event_id);
    if (seen.size > 200) seen.delete(seen.values().next().value);
    try {
      await fetchConversation(accountId, data.conversation_id);
      if (app.$store.getters.getCurrentAccountId !== accountId) return;
      const essential = window.location.pathname.startsWith(
        `/app/accounts/${accountId}/essential`
      );
      useAlert(
        app.$t('TRANSFER_TOAST.RECEIVED', { id: data.conversation_id }),
        {
          type: 'link',
          to: `/app/accounts/${accountId}/${essential ? 'essential/' : ''}conversations/${data.conversation_id}`,
          message: app.$t('TRANSFER_TOAST.OPEN'),
          duration: 10000,
        }
      );
    } catch {
      // Revoked/unavailable conversations must not produce an actionable toast.
    }
  };
}
